import * as Yup from "yup";
import { LASTNAME, FIRSTNAME, EMAIL, PHONE } from "../utils/regex";
import { applyTrimToAllStrings } from "../utils/applyTrimToAll";

const schema = Yup.object({
  lastName: Yup.string()
    .required("Votre nom est requis")
    .matches(
      LASTNAME,
      "Votre nom doit contenir uniquement des lettres, des accents et des espaces",
    ),
  firstName: Yup.string()
    .required("Votre prénom est requis")
    .matches(
      FIRSTNAME,
      "Votre prénom doit contenir uniquement des lettres, des accents et des tirets",
    ),
  address: Yup.string()
    .required("Votre adresse est requise")
    .min(10, "L'adresse saisie semble trop courte"),
  email: Yup.string()
    .required("Votre email est requis")
    .matches(EMAIL, "Veuillez fournir une adresse email valide"),
  phoneNumber: Yup.string()
    .required("Votre numéro de téléphone est requis")
    .matches(PHONE, "Veuillez fournir un numéro de téléphone valide"),
  selectedSlot: Yup.string().required(
    "Veuillez sélectionner un créneau pour votre rendez-vous",
  ),
  services: Yup.array()
    .of(
      Yup.object({
        rateId: Yup.mixed().required(),
        serviceId: Yup.mixed().required(),
        rateName: Yup.string().required(),
        serviceTitle: Yup.string().required(),
      }),
    )
    .min(1, "Veuillez ajouter au moins une prestation")
    .required("Veuillez ajouter au moins une prestation"),
});

export default applyTrimToAllStrings(schema);
